import { createSagaActionTypes } from '../../../utils/actionFactory';

export const SET_ROLE = 'SET_ROLE';
export const UPDATE_ROLE = 'UPDATE_ROLE'

export const actions = createSagaActionTypes('EDIT_ROLE', [
  SET_ROLE,
  UPDATE_ROLE
]);
